import React from 'react';

// import about data
import { videoData } from '../data';

const Aboutvideo = () => {
  // destructure about
  const { image } = videoData;
  return (
    <section
      id='about'
      className='my-[30px] pt-[50px] xl:mt-[100px]'
      data-aos='fade-up'
      data-aos-offset='350'
    >
      <div className='container mx-auto'>
        <div className='bg-accent-about rounded-[50px] min-h-[560px] px-12 pb-12 flex flex-col text-center xl:flex-row xl:items-center xl:text-left  xl:gap-x-[60px] xl:pb-0'>
          {/* image */}
          <div className='flex-1 ml-9' data-aos='zoom-in-left'>
            <img src={image} alt='' />
          </div>
          {/* text */}
          <div className='flex-1 xl:pr-12'>
            <h2 className='h2 mb-10' data-aos='fade-up' data-aos-delay='300'>
            Pentingnya pendidikan agama terhadap karakter anak
            </h2>
            <p
              className='max-w-[474px] font-semibold mx-auto xl:mx-0'
              data-aos='fade-up'
              data-aos-delay='400'
            >
             Dengan diberikannya pendidikan agama pada anak sejak usia dini akan ,menjadikan seorang anak menjadi lebih baik, beragama, bermoral dan bernilai pekerti yang baik. Menyesallah orang tua yang tidak menanamkan atau memberikan pendidikan agama kepada anak-anaknya.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Aboutvideo;